import { getRedirectDomainsApiRequest, getTrackingDomainsApiRequest } from '@/services/api/domains-api';
import { useStore } from '@/store';

export const populateTrackingDomainsStoreCacheApiRequest = async () => {
  const store = useStore();
  const payload = (await getTrackingDomainsApiRequest({
    orderBy: 'updated',
    orderDirection: 'desc',
  })) as TrackingDomain[];
  store.populateTrackingDomainsCache(payload);
  return payload;
};

export const populateRedirectDomainsStoreCacheApiRequest = async () => {
  const store = useStore();
  const payload = (await getRedirectDomainsApiRequest({
    orderBy: 'updated',
    orderDirection: 'desc',
  })) as TrackingDomain[];
  store.populateRedirectDomainsCache(payload);
  return payload;
};
